import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p442696802518519808',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
